import Debug from './_debug';
import $ from 'jquery';
import moment from 'moment';

let SocialWall = {}; 
SocialWall.fbClassWrapper = '.fts-simple-fb-wrapper';
SocialWall.twitterClassWrapper = '.fts-twitter-div';
SocialWall.fbClassItem = '.fts-jal-single-fb-post';
SocialWall.twitterClassItem = '.fts-tweeter-wrap';
SocialWall.fbFeed = []; 
SocialWall.twitterFeed = [];
SocialWall.sortedSocialFeed = [];
SocialWall.socialFeedLimit = 3;

SocialWall.initialize = () => {
  Debug.log('SocialWall: initialize');
  if ($(SocialWall.fbClassWrapper).length > 0 &&
    //$(SocialWall.twitterClassWrapper).length > 0 &&
    $(SocialWall.fbClassItem).length > 0 && 
    //$(SocialWall.twitterClassItem).length > 0 &&
    $('.respifil-social').length > 0) {
    SocialWall.render();
  }
}

SocialWall.render = () => {
  SocialWall.getFbFeed();
  SocialWall.getTwitterFeed();
  SocialWall.getSortedSocialFeed();
  SocialWall.renderGridSocialFeed();
  SocialWall.removeFtsFeeds();
}

SocialWall.getFbFeed = () => {
  $(SocialWall.fbClassItem).each(function(){
    let item = {};
    item.type = 'fb';
    item.date = $(this).find('.fts-jal-fb-post-time').length > 0 ? $(this).find('.fts-jal-fb-post-time').text() : '';
    item.date = moment(item.date, 'DD/MM/YYYY @ HH:mm');
    item.link = $(this).find('.fts-jal-fb-see-more').length > 0 ? $(this).find('.fts-jal-fb-see-more').prop('href').toString() : undefined;
    if (typeof item.link === 'undefined') {
      item.link = $(this).find('.fts-jal-fb-user-name a').prop('href').toString();
    }
    item.message = SocialWall.getCleanMessageText($(this).find('.fts-jal-fb-message'));
    let image = $(this).find('.fts-jal-fb-picture img');
    if (image.length > 0) {
      item.imgSrc = image.attr('src');
    }
    SocialWall.fbFeed.push(item);
  });
  Debug.log(SocialWall.fbFeed);
}

SocialWall.getCleanMessageText = (messageElement) => {
  // Check if the message element exists and is a valid jQuery object with content
  if (messageElement && messageElement.length > 0) {
    // .text() retrieves the text content and removes HTML tags
    let messageText = messageElement.text();
    // .trim() removes whitespace (spaces, tabs, newlines)
    // from the beginning and end of the string.
    return messageText.trim();
  } else {
    // If the element wasn't found or is empty, return an empty string
    Debug.log('Message element provided to getCleanMessageText was not valid or not found.'); // Optional: log for debugging
    return '';
  }
};

SocialWall.getTwitterFeed = () => { //TODO : same tests as fb .length > to be sure it exists
  $(SocialWall.twitterClassItem).each(function(){
    let item = {};
    item.type = 'twitter';
    item.date = $(this).find('.time').text();
    item.date = moment(item.date, 'DD/MM/YYYY @ HH:mm');
    let message = $(this).find('.fts-twitter-text');
    //get right link but not working on prod... due to round number from the server...
    item.link = $(this).find('.fts-tweet-reply-left a').prop('href');
    if (typeof item.link === 'undefined') {
      item.link = message.find('.fts-twitter-caption a').prop('href').toString();
    }  
    message.find('.fts-twitter-caption').remove();
    item.message = message.text();
    let image = $(this).find('.fts-twitter-description-image');
    if (image.length > 0) {
      item.imgSrc = image.attr('src');
    }
    SocialWall.twitterFeed.push(item);
  });  
  Debug.log(SocialWall.twitterFeed);
}

SocialWall.getSortedSocialFeed = () => {
  let concatArray = SocialWall.fbFeed.concat(SocialWall.twitterFeed);
  Debug.log(concatArray);

  SocialWall.sortedSocialFeed = concatArray.sort(function (itemA, itemB) {
    if (itemA.date.isBefore(itemB.date)) {
      return 1;
    }
    if (itemA.date.isAfter(itemB.date)) {
      return -1;
    }
    if (itemA.date.isSame(itemB.date)) {
      return 0;
    }    
  });

  SocialWall.sortedSocialFeed = SocialWall.sortedSocialFeed.slice(0, SocialWall.socialFeedLimit);
  Debug.log(SocialWall.sortedSocialFeed);

}

SocialWall.renderGridSocialFeed = () => {
  let html = '';
  html += '<div class="respifil-social-mosaic row">';
  SocialWall.sortedSocialFeed.forEach(function(item){
    html += '<div class="col-12 col-md-4">';
    html += '<a href="' + item.link + '" class="card aspect-ratio-wrapper aspect-1-1" target="_blank">';
    html += '<div class="card-body aspect-ratio aspect-ratio-top">';
    html += '<div class="row">';
    if (typeof item.type !== 'undefined' && item.type.length > 0) {
      html += '<div class="respifil-social-type col">';
      if (item.type === 'fb') {
        html += '<span class="icon-respifil-fb pr-2"></span>';
        html += '<span>Facebook</span>';
      }
      if (item.type === 'twitter') {
        html += '<span class="icon-respifil-twitter pr-2"></span>';
        html += '<span>Twitter</span>';
      }
      html += '</div>';
    }
    if (typeof item.date !== 'undefined') {
      html += '<div class="respifil-social-date col text-right">' + item.date.format('DD/MM') /*DD/MM - HH:mm*/ + '</div>';
    }
    html += '</div>';
    if (typeof item.imgSrc !== 'undefined' && item.imgSrc.length > 0) {
      html += '<div class="card-img-top aspect-ratio-wrapper aspect-1-2-1">';
      html += '<div class="aspect-ratio aspect-ratio-img h-100" style="background-image:url(' + item.imgSrc + ');"></div>'
      html += '</div>';
    }

    if (typeof item.message !== 'undefined' && item.message.length > 0) {
      // Escape potentially problematic HTML characters.
      // Replace special characters with their corresponding HTML entities.
      // NOTE: The order matters, especially replacing '&' first.
      let escapedMessage = item.message
                             .replace(/&/g, "&amp;")  // Ampersand - Must be FIRST
                             .replace(/</g, "&lt;")   // Less than
                             .replace(/>/g, "&gt;")   // Greater than
                             .replace(/"/g, "&#039;") // Double quote
                             .replace(/'/g, "&quot;"); // Single quote (using ' for broader compatibility than ')
    
      // Append the properly escaped message content
      html += '<div class="respifil-social-message">' + escapedMessage + '</div>'; // Use the escaped variable
    }
    html += '</div>';
    html += '</a>';
    html += '</div>';
  }); 
  html += '</div>';
  $('.respifil-social').append(html);
  return html;
}

SocialWall.removeFtsFeeds = () => {
  $(SocialWall.fbClassWrapper).remove();
  $(SocialWall.twitterClassWrapper).remove();
  $('.fts-jal-fb-header').remove();
  $('#fb-root').remove();
  $('.fts-clear').remove();
}

export default SocialWall;